import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { sendEmailMessage } from "../services/soar";
import FloatingInput from "../common/FloatingInput";

function DeleteFileModal({ show, item, state, handleClose, identifier }) {
  const [reason, setReason] = useState("");
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const handleSave = async () => {
    if (reason === "") {
      toast.error("Please Provide a Reason");
    } else {
      const site = item.webUrl.replace("https://safy365.sharepoint.com", "");
      const url = `https://safy365.sharepoint.com/sites/SDocs/${state.replace(
        " ",
        "%20"
      )}/Forms/AllItems.aspx?env=WebViewList&id=${site}&parentview=7`;

      const newUrl = `https://safy365.sharepoint.com/sites/SDocs/${state.replace(
        " ",
        "%20"
      )}/Forms/AllItems.aspx?env=WebViewList&q=${site}&parentview=7`;

      sendEmailMessage(
        "support@safy.org",
        undefined,
        "Sharepoint File Deletion Request",
        `<p>Please delete the file at the following URL</p><p><a href="${url}">${url}</a></p><p>Reason: <strong>${reason}</strong></p><p>from <strong>${safyInfo.user.displayName}</strong></p>
        <p> or </p>
        <p><a href="${newUrl}">${newUrl}</a></p>`
      );

      toast.success("Request Sent");
      setReason("");
      handleClose();
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>Request to Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-safy2-4">
          <div className="h4 mb-4">{item?.fields?.FileLeafRef}</div>
          <FloatingInput
            nane="reason"
            label="Please provide a reason for the deletion"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer className="bg-safy2-4">
          <div className="btn btn-sm btn-danger" onClick={handleClose}>
            Cancel
          </div>
          <div className="btn btn-sm btn-success" onClick={handleSave}>
            Save
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteFileModal;
